import DataMapper from './DataMapper'
import UserCaseCategoryRM from '../responsemodel/UserCaseCategoryRM';
import UserCaseCategory from '../../models/UserCaseCategory'

export default class UserCaseCategoryDataMapper extends DataMapper<UserCaseCategoryRM, UserCaseCategory> {
  map = (rm: UserCaseCategoryRM) => new UserCaseCategory(
    rm.case_category_id,
    rm.category_name,
    rm.totalCases,
    rm.outOfTatCasesCount,
    rm.outOfTatCases,
    rm.category_code
  )
}